import axios from 'axios';
import User from '../services/User';

export default () => {
  const userProvider = new User();

  axios.interceptors.request.use(async (config) => {
    if (!config.public) {
      if (config.url.includes('v1/user/register') || config.url.includes('v1/user/login') || process.env.NODE_ENV === 'development') {
        const token = await userProvider.getUserToken();
        userProvider.setUserToken(token);
        if (!config.headers.common['X-Id-Token']) {
          config.headers.common['X-Id-Token'] = token;
        }
      }
    }
    return config;
  }, err => Promise.reject(err));

  axios.interceptors.response.use(response => response, error => Promise.reject(error.response.data));
};



// WEBPACK FOOTER //
// ./app/src/shared/axiosInterceptor.js